import moment from "moment";
import React from "react";
import * as BS from "react-bootstrap";
import { FormField } from "./";
import { ValidatedFormFieldBase } from "../validation";
import { Icon } from "../generic";
// import ReactDOM from "react-dom";
import { Utility } from "../../utils";

interface OwnProps {
    format?: string;
    inputCss?: string;
    onInputChange?: (fieldName: string, value: string) => void;
    placeholder?: string;
    reverseYears?: boolean;
    yearRange?: number[];
    years?: number[];
}

interface OwnState {
    show: boolean;
    year: number;
}

export class MonthPickerField extends ValidatedFormFieldBase<OwnProps, OwnState> {
    public constructor(props: any) {
        super(props);
        this.state = {
            show: false,
            year: new Date().getFullYear(),
        };
    }

    public render() {
        const format = this.props.format || "MM/YYYY";
        let value: Date | undefined | null = this.getValue(true);

        if (typeof value === "string")
            value = Utility.fromApiDate(value);

        if (value !== undefined && value !== null && !(value instanceof Date))
            value = undefined;

        const valueFormatted = value ? moment(value).format(format) : "";
        const currMonth = value ? value.getMonth() : undefined;
        const on = "primary";
        const off = "default";

        let yearSelector = <BS.Grid bsClass="">
            <BS.Row>
                <BS.Col xs={4}>
                    <BS.Button bsStyle="primary" onClick={() => this.setYear(this.state.year - 1)} title="Previous year">
                        <Icon icon="chevron-left" />
                    </BS.Button>
                </BS.Col>

                <BS.Col xs={4}>{this.state.year}</BS.Col>

                <BS.Col xs={4}>
                    <BS.Button className="pull-right" bsStyle="primary" onClick={() => this.setYear(this.state.year + 1)} title="Next year">
                        <Icon icon="chevron-right" />
                    </BS.Button>
                </BS.Col>
            </BS.Row>
        </BS.Grid>;

        let years: number[] = [];

        if (this.props.yearRange && this.props.yearRange.length === 2) {
            for (let y = this.props.yearRange[0]; y <= this.props.yearRange[1]; y++) {
                years.push(y);
            }
        }
        else if (this.props.years && this.props.years.length)
            years = this.props.years;

        if (years.length) {
            if (this.props.reverseYears)
                years = years.reverse();

            yearSelector = <select
                    className="txt"
                    onChange={(e) => this.setYear(e.target.value as any as number)}
                    value={this.state.year}
                >
                {years.map((y, i) => (
                    <option key={i} value={y}>{y}</option>
                ))}
                </select>;
        }

        return <FormField {...this.props} errors={this.getErrors()} label={this.getLabel(this.props.label)} name={this.props.name} required={this.isRequired(this.props.required)}>
            <div className="month-picker">
                <input
                    type="text"
                    className={this.props.inputCss || "txt-date"}
                    name={this.props.name}
                    onFocus={(e) => { e.target.blur(); this.toggleShow(true); }}
                    onMouseUp={() => this.toggleShow(true)}
                    onTouchEnd={() => this.toggleShow(true)}
                    placeholder={this.props.placeholder}
                    readOnly
                    value={valueFormatted}
                />

                <BS.Button onClick={() => this.clearValue()} title="Clear date" style={{ display: value ? "inline" : "none" }}>
                    <Icon icon="times" />
                </BS.Button>

                <BS.Modal backdrop bsSize="sm" keyboard show={this.state.show} onHide={() => {}}>
                    <BS.Modal.Header>
                        {yearSelector}
                    </BS.Modal.Header>

                    <BS.Modal.Body>
                        <BS.Grid bsClass="">
                            <BS.Row>
                                <BS.Col xs={4}><BS.Button className="btn-block" bsStyle={currMonth === 0 ? on : off} onClick={() => this.onSelect(0)}>Jan</BS.Button></BS.Col>
                                <BS.Col xs={4}><BS.Button className="btn-block" bsStyle={currMonth === 1 ? on : off} onClick={() => this.onSelect(1)}>Feb</BS.Button></BS.Col>
                                <BS.Col xs={4}><BS.Button className="btn-block" bsStyle={currMonth === 2 ? on : off} onClick={() => this.onSelect(2)}>Mar</BS.Button></BS.Col>
                            </BS.Row>
                            <BS.Row>
                                <BS.Col xs={4}><BS.Button className="btn-block" bsStyle={currMonth === 3 ? on : off} onClick={() => this.onSelect(3)}>Apr</BS.Button></BS.Col>
                                <BS.Col xs={4}><BS.Button className="btn-block" bsStyle={currMonth === 4 ? on : off} onClick={() => this.onSelect(4)}>May</BS.Button></BS.Col>
                                <BS.Col xs={4}><BS.Button className="btn-block" bsStyle={currMonth === 5 ? on : off} onClick={() => this.onSelect(5)}>Jun</BS.Button></BS.Col>
                            </BS.Row>
                            <BS.Row>
                                <BS.Col xs={4}><BS.Button className="btn-block" bsStyle={currMonth === 6 ? on : off} onClick={() => this.onSelect(6)}>Jul</BS.Button></BS.Col>
                                <BS.Col xs={4}><BS.Button className="btn-block" bsStyle={currMonth === 7 ? on : off} onClick={() => this.onSelect(7)}>Aug</BS.Button></BS.Col>
                                <BS.Col xs={4}><BS.Button className="btn-block" bsStyle={currMonth === 8 ? on : off} onClick={() => this.onSelect(8)}>Sep</BS.Button></BS.Col>
                            </BS.Row>
                            <BS.Row>
                                <BS.Col xs={4}><BS.Button className="btn-block" bsStyle={currMonth === 9 ? on : off} onClick={() => this.onSelect(9)}>Oct</BS.Button></BS.Col>
                                <BS.Col xs={4}><BS.Button className="btn-block" bsStyle={currMonth === 10 ? on : off} onClick={() => this.onSelect(10)}>Nov</BS.Button></BS.Col>
                                <BS.Col xs={4}><BS.Button className="btn-block" bsStyle={currMonth === 11 ? on : off} onClick={() => this.onSelect(11)}>Dec</BS.Button></BS.Col>
                            </BS.Row>
                        </BS.Grid>
                    </BS.Modal.Body>

                    <BS.Modal.Footer>
                        <BS.Button bsStyle="primary" onClick={() => this.toggleShow(false)}>Close</BS.Button>
                    </BS.Modal.Footer>
                </BS.Modal>
            </div>
        </FormField>;
    }

    private clearValue() {
        this.props.formComponent.setFieldValue(this.props.name, undefined);
    }

    private onSelect(month: number) {
        const date = new Date(this.state.year, month, 1);
        this.props.formComponent.setFieldValue(this.props.name, date);
        this.toggleShow(false);
    }

    private setYear(year: number) {
        this.setState({ ...this.state, year });
    }

    private toggleShow(show: boolean) {
        this.setState({ ...this.state, show });
    }
}



// WEBPACK FOOTER //
// ./src/components/editors/MonthPickerField.tsx